export const SOURCE_TYPES = { CATEGORY: 'category', CUSTOM: 'custom' };
